export default {
    isnow(date){
       let N_date = new Date(date).getTime();
       return N_date>new Date().getTime()?true:false;
    },
   //获取昨天
   getyDay(date) {
      date.setTime(date.getTime() + 24 * 60 * 60 * 1000 * 10);
      date =
        date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
      return date;
    },
    //获取上个月
    getLmDay(date) {
      date.setTime(date.getTime() - 24 * 60 * 60 * 1000 * 30);
      date =
        date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
      return date;
    },
    //格式化日期
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    },
 //处理数组转字符串
    //数组转字符串[1,2,3]=>"1,2"  obj:数组
    acTiveArrStringFun(obj) {
      let string = obj.replace(/"/g, "").replace(/]/g, "").replace(/\[/g, "");
      return string;
    },
    //根据身份证号获取年龄，idcard：身份证号
    getage(idcard) {
      let myDate = new Date();
      let month = myDate.getMonth() + 1;
      let day = myDate.getDate();
      let age = myDate.getFullYear() - idcard.substring(6, 10) - 1;
      if (
        idcard.substring(10, 12) < month ||
        (idcard.substring(10, 12) == month &&
          idcard.substring(12, 14) <= day)
      ) {
        age++;
      }
      return age.toString();
    },
    //根据生日获取   birthdy ：YYYY-mm-dd 字符串
   getthismoth(birthdy){
      let  Mydate = new Date().getTime()
      let Bdate = new Date(birthdy).getTime()
      let monthdate = new Date(Mydate - Bdate).getMonth()+1
      return monthdate;
   },
   //根据生日获取性别  idcard:身份证号
   getgenderIDbyIdCard(idcard) {
      if (parseInt(idcard.substr(16, 1)) % 2 == 1) {
        //男
        return "男";
      } else {
        //女
        return "女";
      }
    },
    //根据身份证号获取籍贯
    //idcard ：身份证，Arr地区列表
    getaddressID(idCard,arr) {
      if (!idCard || idCard.length < 6) return "";
      let provinceNo = idCard.substring(0, 2) + "0000";
      let cityNo = idCard.substring(0, 4) + "00";
      let countyNo = idCard.substring(0, 6);
      let provinceName = arr.province_list[provinceNo];
      // console.log(provinceName)
      let cityName = arr.city_list[cityNo];
      let countyName = arr.county_list[countyNo];
      let result =
        {
          ProvinceId:provinceNo,
          ProvinceName:provinceName,
          CityId:cityNo,
          CityName:cityName,
          CountyId:countyNo,
          CountyName:countyName
        }

      return result;
    },
    //根据对象value拿name
    // value :对象里已获取的属性，info 对象，type 需要获取的其他属性
    findValueByname(value, info,type) {
      // for (let temp in info) {
      //   if (info[temp].value == value) {
      //     return info[temp].name;
      //   }
      // }
      return info.find((info) => info.value === value).type;
    },
 }